// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2ectK","label":"SetPasswdForm_label__ErfwA"};